import {
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import { DatePicker } from "@material-ui/pickers";
import { EnumCatSexo } from "../../../../settings/enumConfig";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocInputPhone from "../../../utils/MeditocInputPhone";
import { useCallCenter } from "../../../../context/CallCenterContext";

export default function FormPaciente() {
    const {
        formPaciente,
        handleChangeFormPacienteText,
        handleChangeFormPacienteDate,
        handleClickActualizarDatosPaciente,
    } = useCallCenter();

    const { txtCCFolio, txtCCNombre, txtCCTelefono, txtCCCorreo, txtCCFechaNacimiento, txtCCTipoSangre, txtCCSexo } =
        formPaciente;

    return (
        <Grid container spacing={3}>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCFolio"
                    label={txtCCFolio.label}
                    required={txtCCFolio.required}
                    value={txtCCFolio.value}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCNombre"
                    label={txtCCNombre.label}
                    required={txtCCNombre.required}
                    value={txtCCNombre.value}
                    error={txtCCNombre.error}
                    helperText={txtCCNombre.error && txtCCNombre.message}
                    onChange={handleChangeFormPacienteText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCTelefono"
                    label={txtCCTelefono.label}
                    required={txtCCTelefono.required}
                    value={txtCCTelefono.value}
                    error={txtCCTelefono.error}
                    helperText={txtCCTelefono.error && txtCCTelefono.message}
                    onChange={handleChangeFormPacienteText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    InputProps={{
                        inputComponent: MeditocInputPhone,
                    }}
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCCorreo"
                    label={txtCCCorreo.label}
                    required={txtCCCorreo.required}
                    value={txtCCCorreo.value}
                    error={txtCCCorreo.error}
                    helperText={txtCCCorreo.error && txtCCCorreo.message}
                    onChange={handleChangeFormPacienteText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                />
            </Grid>

            <Grid item sm={6} xs={12}>
                <DatePicker
                    name="txtCCFechaNacimiento"
                    label={txtCCFechaNacimiento.label}
                    required={txtCCFechaNacimiento.required}
                    value={txtCCFechaNacimiento.value}
                    error={txtCCFechaNacimiento.error}
                    helperText={txtCCFechaNacimiento.error && txtCCFechaNacimiento.message}
                    onChange={(date) => handleChangeFormPacienteDate(date, "txtCCFechaNacimiento")}
                    InputProps={{ endAdornment: <MeditocDateIcon /> }}
                    views={["year", "month", "date"]}
                    inputVariant={inputVariant}
                    format="dd/MM/yyyy"
                    color={inputColor}
                    variant="inline"
                    disableFuture
                    openTo="year"
                    fullWidth
                    autoOk={true}
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCTipoSangre"
                    label={txtCCTipoSangre.label}
                    required={txtCCTipoSangre.required}
                    value={txtCCTipoSangre.value}
                    onChange={handleChangeFormPacienteText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    select
                >
                    <MenuItem value="A+">A+</MenuItem>
                    <MenuItem value="A-">A-</MenuItem>
                    <MenuItem value="B+">B+</MenuItem>
                    <MenuItem value="B-">B-</MenuItem>
                    <MenuItem value="AB+">AB+</MenuItem>
                    <MenuItem value="AB-">AB-</MenuItem>
                    <MenuItem value="O+">O+</MenuItem>
                    <MenuItem value="O-">O-</MenuItem>
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <FormControl>
                    <FormLabel>Sexo</FormLabel>
                    <RadioGroup name="txtCCSexo" row value={txtCCSexo.value} onChange={handleChangeFormPacienteText}>
                        <FormControlLabel value={EnumCatSexo.Hombre.toString()} control={<Radio />} label="Hombre" />
                        <FormControlLabel value={EnumCatSexo.Mujer.toString()} control={<Radio />} label="Mujer" />
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={12} className="right">
                <Button variant="contained" color="primary" onClick={handleClickActualizarDatosPaciente}>
                    Actualizar datos de paciente
                </Button>
            </Grid>
        </Grid>
    );
}
